export const hoursToTime = (hours: number | [number, number] | null) => {
  if (Array.isArray(hours)) {
    const [h, m] = hours
    return `${h}h ${m}m`
  }
  if (hours === null) return '0h 0m'
  const totalMinutes = Math.floor(hours * 60)
  const hoursPart = Math.floor(totalMinutes / 60)
  const minutesPart = totalMinutes % 60
  return `${hoursPart}h ${minutesPart}m`
}
